import { useMemo } from 'react';

import { Modal, Text } from '@thefarmersfront/kitchen';

import { ResultStatusSummary, Table } from '~/components/common';

import { getOrderRegisterExcelUploadFailColumnDefs } from '~/utils/order';

import type { TypePostOrderExcelResponse } from '~/types/order.types';

import styles from './OrderExcelUploadFailModal.module.scss';

type TypeOrderExcelUploadFailModalProps = {
  failData: TypePostOrderExcelResponse;
  open: boolean;
  onClose: () => void;
};

/** 실패 내역 표 높이. 건수가 많아도 모달이 늘어나지 않고 표 안에서 스크롤한다. */
const TABLE_HEIGHT = 396;

const OrderExcelUploadFailModal = ({ failData, open, onClose }: TypeOrderExcelUploadFailModalProps) => {
  const { totalCount, successCount, failCount, failResults } = failData;

  const { columnDefs } = useMemo(() => getOrderRegisterExcelUploadFailColumnDefs(), []);

  return (
    <Modal title="주문 엑셀 일괄 등록 실패" size="large" open={open} onConfirm={onClose}>
      <div className={styles['contents-container']}>
        <ResultStatusSummary totalCount={totalCount} successCount={successCount} failCount={failCount} />
        <div className={styles['view-section']}>
          <div className={styles['table-title-wrapper']}>
            <Text size="large" weight="semi-bold">
              업로드 실패 내역
            </Text>
          </div>
          <div className={styles['table-wrapper']}>
            <Table className={styles['table']} data={failResults} columns={columnDefs} height={TABLE_HEIGHT} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OrderExcelUploadFailModal;
